<template>
  <div
    :class="{
      flex: variant === 'horizontal',
    }"
  >
    <portal to="dashboard-header">
      <ul
        style="height: 48px"
        :class="{
          flex: variant === 'vertical',
          'flex-wrap': variant === 'vertical',
        }"
      >
        <li v-for="(tab, index) in tabList" :key="index" class="mx-20">
          <label
            :for="`${_uid}${index}`"
            @click="onTabChange(tab)"
            v-if="tab"
            v-text="$t(`${tab.toLowerCase()}`)"
            class="text-14 font-semibold tab-label cursor-pointer"
            :class="activeTab === tab ? 'text-blueText border-b-2 border-blue' : ''"
          />
          <input
            :id="`${_uid}${index}`"
            type="radio"
            :name="`${_uid}-tab`"
            :value="tab"
            v-model="activeTab"
            class="hidden"
          />
        </li>
      </ul>
    </portal>

    <transition name="slide" mode="out-in">
      <template v-for="(tab, index) in tabList">
        <div :key="index" v-if="tab === activeTab">
          <slot :name="`tabPanel-${tab}`" />
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import EventBus from '@/utils/EventBus';

export default {
  props: {
    tabList: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: () => 'vertical',
      validator: (value) => ['horizontal', 'vertical'].includes(value),
    },
  },
  data() {
    return {
      activeTab: 'dashboard',
    };
  },
  mounted() {
    EventBus.$on('triggerTabChange', (activeTab) => {
      if (activeTab) {
        this.activeTab = this.tabList.find((tab) => tab === activeTab);
        this.$router
          .replace({
            path: this.$route.path,
            query: { active: activeTab },
          })
          .catch(() => {});
      }
    });
    if (this.$route.query && this.$route.query.active) {
      this.activeTab = this.tabList.find((tab) => tab === this.$route.query.active);
    }
  },
  methods: {
    onTabChange(tabName) {
      this.$emit('onTabChange', tabName);
      this.$router.replace({ path: this.$route.path, query: { active: tabName } }).catch(() => {});
    },
  },
};
</script>
<style>
.tab-label {
  @apply pb-22;
}
.slide-enter-active,
.slide-leave-active,
.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}
.slide-enter,
.slide-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}
.slide-leave-active,
.slide-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
